import React from 'react';
import TeaserFrame2 from "../../TeaserFrame2";
import {Grid, Typography} from "@mui/material";
import goatGif from '../../../assets/images/goat-this.gif';
import ListInfo from "../../kozel/ListInfo";
import useTeaserBeMemberStyles from "../../../styles/kozelMeetBoardGame/first_screen/teaser_be_member";

const ContentTeaser: React.FC = () => {
    const listItems = [
        {text: 'Your friends'},
        {text: 'Cool challenges'},
        {text: 'G.O.A.T. prizes and experiences'},
        {text: 'Interactive games,  fun and good mood'},
        {text: 'Access to G.O.A.T. events at Kozel locations'},
        {text: 'You connect with great people, over a most delicious Czech beeeeer!'},
    ]
    return (
        <ListInfo items={listItems} hasContrast={true}/>
    );
}
const TeaserBeMember: React.FC = (props) => {
    const styles = useTeaserBeMemberStyles();
    return (
        <Grid container>
            <Grid item xs={12} className={styles.boxTeaserFrame}>
                <TeaserFrame2 title={''}>
                    <Grid container
                          justifyContent={"center"}
                          alignItems={"center"}
                          alignContent={"center"}
                          p={3}
                    >
                        <Grid item xs={12} lg={4}
                              display={"flex"}
                              flexDirection={"column"}
                              justifyContent={"center"}
                              alignItems={"center"}
                              alignContent={"center"}
                              className={styles.boxLeft}
                        >
                            <Typography className={styles.title}>GOATIFUL!</Typography>
                            <Typography className={styles.subtitle}>I AM HAPPY YOU ARE HERE.</Typography>
                            <img src={goatGif} alt={'Teaser logo kozel'} className={styles.goatGif}/>
                        </Grid>
                        <Grid item xs={12} lg={8} className={styles.boxRight}>
                            <Typography className={styles.teaserTitle}>WHAT AWAITS YOU HERE:</Typography>
                            <ContentTeaser/>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid>
        </Grid>
    );
}

export default TeaserBeMember;
